import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { PageHeader, PageShell } from "../../../design-system/tableUi";
import SshPolicyManager from "../ssh-proxy/policy/SshPolicyManager";

// PAM → Policies: every Endpoint Policy across every gateway. The same manager
// the gateway's Policy tab uses, unscoped (the gateway is a column), with its
// count and New policy.
//
// ?host=<address> opens the New policy dialog with that host picked — where
// "write a policy for this host" links from onboarding land. A ?gateway= on
// those links is ignored: the host's endpoint already has its gateway.
// Password rotation is set per account on Endpoint Users; old
// ?tab=password-rotation links are sent there.
export default function SshPoliciesPage() {
  const [searchParams] = useSearchParams();

  if (searchParams.get("tab") === "password-rotation") {
    return <Navigate to="/pam/endpointsUsers" replace />;
  }

  return (
    <PageShell>
      <PageHeader
        eyebrow="PAM · Policies"
        title="Policies"
        subtitle="Who may reach which accounts on which endpoints, through which gateway."
      />
      <SshPolicyManager
        embedded
        presetHost={searchParams.get("host") || undefined}
      />
    </PageShell>
  );
}
